import Vue from 'vue'
import Vuex from 'vuex'
import pathify, { make } from 'vuex-pathify'
import schools from '@/store/modules/schools'
import school from '@/store/modules/school'
import location from '@/store/modules/location'

Vue.use(Vuex)

const state = {
}

const store = new Vuex.Store({
  plugins: [pathify.plugin],
  modules: { schools, school, location },

  state,

  mutations: make.mutations(state),

  actions: {
    ...make.actions(state),
  },

  getters: {},

  strict: process.env.NODE_ENV !== 'production',
})

export default store
